/*
 * Орган «Настройки» в шапке (модель писателя · стиль по умолчанию) и его диалог. Соседствует
 * с рубильником публикаций и намеренно ТИШЕ его: рубильник — состояние канала (крупная
 * дорожка, заметная боковым зрением), настройки — как канал пишет. Одинаковая громкость двух
 * органов рядом заставила бы читать оба на каждом экране, хотя срочный из них один.
 *
 * Подсказка повторяет геометрию `ModeSwitch.module.css` дословно: два всплывающих блока в
 * одной шапке, расходящиеся шириной и отступом, читаются как два разных механизма. Ту же
 * геометрию повторяют поповеры ⓘ партии 19.09 (`InfoPopover.module.css`).
 */

.wrap {
  position: relative;
  display: flex;
  align-items: center;
  flex: none;
}

.btn {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  background: none;
  border: 1px solid transparent;
  padding: 5px 9px;
  border-radius: var(--r-ctl);
  font-family: var(--sans);
  cursor: pointer;
  white-space: nowrap;
}
.btn:hover {
  background: var(--bg-alt);
}

/* Отклонение от умолчаний (модель не из конфига бренда ИЛИ стиль не релиз) обязано быть
   видно без наведения: это ответ на вопрос «почему посты вдруг другие», и прятать его в
   подсказку значит прятать причину. */
.on {
  border-color: var(--border);
  background: var(--bg-alt);
}

.cap {
  font-size: 11px;
  color: var(--muted);
  letter-spacing: 0.01em;
}

.name {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink);
  /* Имя стиля — до 40 знаков (`STYLE_NAME_MAX`), и «Opus 5 · v6 — короче абзацы» раздвинуло
     бы шапку за край окна. Потолок держит орган на месте; полное значение — в подсказке и в
     `aria-label`. */
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Значок органа — только на телефоне (см. блок 640 ниже). */
.glyph {
  display: none;
  color: var(--ink-2);
}

/* Ступень лестницы шапки 1599 (Shell.module.css): подпись «Настройки» уходит вместе с длинной
   подписью главной кнопки — значение «Opus 5 · v5» без неё читается, она без значения не
   говорит ничего. */
@media (max-width: 1599px) {
  .cap {
    display: none;
  }
}

/*
 * Телефон (640): уходят и значение, и подпись — «Настройки» шире прежней «Модели» на 20px, и
 * вместе с кнопкой «Прогон мониторинга» шапка на 390px переставала помещаться. Орган
 * становится значком-ползунками: видимым обязано остаться ХОТЬ ЧТО-ТО, иначе он превращается
 * в нажимаемое ничто, а правило шапки «ни один орган не исчезает» держится на том, что орган
 * ВИДЕН. Значение остаётся в `aria-label` кнопки и во всплывающей подсказке, то есть из DOM
 * не удаляется (docs/ui-design.md §4.1, правило 2).
 */
@media (max-width: 640px) {
  .btn {
    align-items: center;
    padding: 6px 7px;
  }
  .glyph {
    display: inline-flex;
  }
  .cap,
  .name {
    display: none;
  }
}

.tip {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 30;
  width: 300px;
  max-width: 78vw;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border-radius: var(--r-ctl);
  background: var(--white);
  border: 1px solid var(--border);
  box-shadow: var(--sh-float);
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--ink-2);
  text-align: left;
  /* Прозрачностью, а не visibility: блок связан через `aria-describedby`, и скрытый по
     visibility выпал бы из дерева доступности. Та же причина, что в ModeSwitch. */
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s var(--ease);
}
.tip b {
  font-size: 13px;
  color: var(--ink);
}
.tipNote {
  color: var(--muted);
}

.wrap:hover .tip,
.wrap:focus-within .tip {
  opacity: 1;
}

@media (prefers-reduced-motion: reduce) {
  .tip {
    transition: none;
  }
}

.field {
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

/* Ссылка на редактор стоит под чипами стилей, к которым относится: редактор — это место, где
   версии заводят и правят, а здесь из них только выбирают. */
.editorLink {
  align-self: flex-start;
  font-size: 13px;
  font-weight: 500;
}

/* Отказов может быть два (модель и стиль — два маршрута): каждый своей строкой. */
.errors {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
